import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { contains } from 'ramda';

import { connect} from 'react-redux';
import { LOGOUT_REQUEST } from '../../constants/ActionTypes';
import { logout } from '../../actions/session/sessionActions';

import LoadingState from '../LoadingState';
import Layout from '../Layout';
import ErrorMessage from '../ErrorMessage';

import s from './Logout.css';


export class Logout extends Component {
    static propTypes = {
        history: object,
        loadingState: object,
        location: object,
        logoutRequest: func.isRequired,
        match: object,
    };

    componentDidMount() {
        this.props.logoutRequest();
    }

    render = () => {
        const isLoading = contains(LOGOUT_REQUEST, this.props.loadingState.requests || []);

        return (
            <Layout column fullscreen className={s.component}>
                <ErrorMessage
                    title="You have now been logged out of your secure conversation."
                    message="Please close this browser window, thank you!"
                    noMargin
                />
                {isLoading &&
                    <div className={s.loadingState}>
                        <p>Logging out...</p>
                        <LoadingState context="logout" />
                    </div>
                }
            </Layout>
        )
    }
}

const mapStateToProps = state => ({
    loadingState: state.loadingState,
});

const mapDispatchToProps = dispatch => ({
    logoutRequest: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
